import { BottomSheet as Sheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { STOCK_LIST } from "../constants";
import { usePopupBackground } from "../hooks/usePopupBackground";
import Lottie from "react-lottie-player";
import { useState, useEffect } from "react";
import * as Loading from "./lottie/typing.json";
import "./style.css";

export interface BottomSheetProps {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
}

export const BottomSheet = ({ isOpen, setOpen }: BottomSheetProps) => {
  const [isShow, setIsShow] = useState(false);
  const [isPlayed, setIsPlayed] = useState(false);

  const referralCode = new URLSearchParams(window.location.search).get("code");

  const url = referralCode
    ? `https://dominoapp.onelink.me/vY2c/2u1bcxu8?inviteCode=${referralCode}&deep_link_sub1=${referralCode}`
    : "https://dominoapp.onelink.me/vY2c";

  const onDissmiss = () => {
    setOpen(false);
  };

  const handleOverflowBody = () => {
    document.body.style.height = "100vh";
    document.body.style.overflowY = "hidden";
  };

  const handleBodyAutoSize = () => {
    document.body.style.height = "auto";
    document.body.style.overflowY = "auto";
  };

  const { showBackground } = usePopupBackground({ isOpen });

  useEffect(() => {
    const item = document.querySelector("[data-rsbs-scroll]");

    if (isPlayed) {
      setTimeout(() => {
        item?.scrollTo(0, 1000);
      }, 100);
      setIsPlayed(false);
    }
  }, [isPlayed]);

  return (
    <div
      className={`bottomSheetBackground ${showBackground ? "open" : "close"}`}
      onClick={(event) => event.stopPropagation()}
    >
      <Sheet
        open={isOpen}
        blocking={false}
        snapPoints={({ minHeight }) => minHeight}
        onDismiss={onDissmiss}
        expandOnContentDrag={true}
        onSpringStart={(event) => {
          if (event.type === "OPEN") handleOverflowBody();
          if (event.type === "CLOSE") handleBodyAutoSize();
        }}
      >
        <div className="bottomSheet__header">
          <h3 className="bottomSheet__header__title">도미노 AI</h3>
          <div className="bottomSheet__header__text">
            <img src="/images/GPT.svg" alt="" />
          </div>
        </div>
        <div className="bottomSheet__chatList">
          <div className="bottomSheet__defaultChat">
            <img src="images/stocks/TSLA.png" alt="" className="chat__stock" />
            <div className="chat__imageBox">
              <img src="images/first_chat.png" alt="" className="chat" />
            </div>
          </div>
          <div className="bottomSheet__loadingChat">
            <img src="images/stocks/TSLA.png" alt="" className="chat__stock" />
            {!isShow ? (
              <div className="chat__lottieBox">
                <Lottie
                  className="lottie"
                  animationData={Loading}
                  play
                  loop
                  onLoopComplete={() => {
                    setIsShow(true);
                    setIsPlayed(true);
                  }}
                />
              </div>
            ) : (
              <div className="chat__imageBox2">
                <img src="images/second_chat.png" alt="" className="chat" />
              </div>
            )}
          </div>
        </div>
        <ul className="bottomSheet__stockList">
          <a href={url} className="bottomSheet__stock--default">
            <img src="/images/icon_star.svg" alt="" />
            <span>종목찾기</span>
          </a>
          {STOCK_LIST.map((stock) => (
            <a href={url} className="bottomSheet__stock" key={stock.ticker}>
              <img src={stock.logo} alt={stock.ticker} />
              <span>{stock.ticker}</span>
            </a>
          ))}
        </ul>
      </Sheet>
    </div>
  );
};
